/**
 * The three small semantics every document rule leans on, kept identical to what v1 used so a
 * port stays a port.
 */

/**
 * lodash `isEmpty`, which v1 printHelper calls throughout. Written out rather than imported so the
 * package keeps its two-dependency surface — and its quirks matter: a NUMBER is "empty", so v1
 * replaces a ticket's numeric `createdBy.date` with the current time.
 */
export function isEmpty(value: unknown): boolean {
  if (value == null) return true;
  if (typeof value === "string" || Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value as object).length === 0;
  return true;
}

/**
 * A deep copy, so a rule can never mutate the caller's sale. `structuredClone` where the runtime
 * has it (web used it), JSON otherwise (Hermes has none; mobile used JSON). The library
 * JSON-clones its input on entry anyway, so what reaches a template is the same either way.
 */
export function clone<T>(value: T): T {
  if (value === undefined) return value;
  const native = (globalThis as { structuredClone?: <V>(v: V) => V }).structuredClone;
  return native ? native(value) : JSON.parse(JSON.stringify(value));
}

/**
 * A copy count as v1's `while (copies) { …; --copies }` loop spends it — except that loop never
 * ended for a negative, fractional or "0"-string count. Those print nothing here.
 */
export function toCount(copies: unknown): number {
  const n = Math.floor(Number(copies));
  return Number.isFinite(n) && n > 0 ? n : 0;
}
